module.exports = __webpack_public_path__ + "img/platform1.c0c6aaa1.png";